import Component from '@glimmer/component';
import Owner from '@ember/owner';

// Marker is called when this component is instantiated during rendering
// Because it will always be called during rendering, marker must not affect render state
interface AppearanceMarkerArgs {
  marker: () => void;
}

interface AppearanceMarkerSignature {
  Args: AppearanceMarkerArgs;
}
export default class AppearanceMarker extends Component<AppearanceMarkerSignature> {
  /**
   * @param {*} owner
   * @param {*} args
   */
  constructor(owner: Owner, args: AppearanceMarkerArgs) {
    super(owner, args);
    if (this.args.marker) {
      this.args.marker();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    AppearanceMarker: typeof AppearanceMarker;
  }
}
